import { Component, OnInit } from '@angular/core';
import { AuthService } from '@app/@core/services/auth.service';
import { PermissionStore } from '@app/@core/store/permission.store';
import { environment } from '@env/environment';
import { BehaviorSubject, Subscription } from 'rxjs';
import { LocalService } from '@core/services/local.service';

@Component({
  standalone: false,
  selector: 'app-workflow',
  templateUrl: './workflow.component.html',
  styleUrls: ['./workflow.component.scss']
})
export class WorkflowComponent implements OnInit {
  RBACORG: any;
  PERMISSION: any;
  orgSubs: Subscription;
  n8nEvent: BehaviorSubject<any>;
  constructor(private permissionStore: PermissionStore, private authService: AuthService, private sessionStorage: LocalService) {
    this.n8nEvent = new BehaviorSubject<any>(null);
    this.orgSubs = this.authService.orgInfo.subscribe(o => {
      console.log('PermissionsComponent');
      this.PERMISSION = this.permissionStore.state;
      this.RBACORG = {
        tokenKey: 'jwt-token',
        apiHost: environment.apiHost,
        others: this.sessionStorage.asStorage(),
        orgID: o ? o : this.sessionStorage.getItem('orgid'),
        environment: {
          mstrUsername: environment.mstrUsername,
          mstrPassword: environment.mstrPassword,
          mstrURL: environment.mstrURL,
          mstrProjectID: environment.mstrProjectID,
          applicationid: environment.applicationid,
          priority: environment.priority,
          videoConferenceDomain: environment.videoConferenceDomain,
          ChatBotNew: environment.ChatBotNew,
          ChatBot: environment.ChatBot,
          n8nWorflowUrl: environment.n8nWorflowUrl,
          production: environment.production
        }
      };
      this.n8nEvent.next({
        RBACORG: this.RBACORG,
        PERMISSION: this.PERMISSION
      });
    });
  }
  ngOnInit(): void {
    console.log();
  }
  // eslint-disable-next-line @angular-eslint/use-lifecycle-interface
  ngOnDestroy(): void {
    this.orgSubs.unsubscribe();
  }
}
